var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import deleteOrganisationUser from '../../requests/organisation/deleteOrganisationUser';
import Signals from '../../signals/Signals';
/**
 *
 */
var DeleteOrganisationUserCommand = /** @class */ (function (_super) {
    __extends(DeleteOrganisationUserCommand, _super);
    function DeleteOrganisationUserCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param organisation OrganisationModel
     * @param user UserModel
     * @param userCollection UserCollection
     * @param intl
     * @return {*}
     */
    DeleteOrganisationUserCommand.prototype.execute = function (organisation, user, userCollection, intl) {
        this.organisation = organisation;
        this.user = user;
        this.userCollection = userCollection;
        this.intl = intl;
        var promise = deleteOrganisationUser(organisation.id, user.id);
        promise.then(this.then);
        promise.catch(this.catch);
        return promise;
    };
    DeleteOrganisationUserCommand.prototype.then = function (response) {
        this.userCollection.remove(this.user);
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.user.deleted' }, Object(this.user)), 'dark', true);
    };
    return DeleteOrganisationUserCommand;
}(Command));
export default DeleteOrganisationUserCommand;
